import React from 'react'
import { DateTime } from 'luxon'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import EventOutlinedIcon from '@material-ui/icons/EventOutlined'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import AddToCalendarButton from 'components/add-to-calendar-button'
import CancelBookingDialog from 'components/cancel-booking-dialog'
import ModifySessionDialog from 'components/modify-session-dialog'

const useStyles = makeStyles(theme => ({
  actionButtonContainer: {
    position: 'absolute',
    top: '-16px',
    right: '24px',
    '& button': {
      color: theme.palette.text.primary,
    },
  },
}))

const makeCalendarEvent = ({
  id,
  startDateTime,
  endDateTime,
  title,
  description,
  coachFacility,
}) => ({
  uid: `coach-tools.lesson.${id}.pga.com`,
  startDateTime: DateTime.fromISO(startDateTime),
  endDateTime: DateTime.fromISO(endDateTime),
  title,
  description: description,
  location: coachFacility?.name,
  url: `${window.location.origin}/pga-coach/bookings/schedule`,
})

const ActionButtons = ({ booking, onReschedule, onCancellation }) => {
  const { isCanceled } = booking
  const { confirmationCode } = booking.enrollments[0]

  const [isRescheduleLessonEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_RESCHEDULE_LESSON,
  ])

  const classes = useStyles()

  return (
    <Box className={classes.actionButtonContainer}>
      {isRescheduleLessonEnabled ? (
        <ModifySessionDialog
          trigger={
            <Tooltip title="Modify session">
              <IconButton>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          }
          onSuccess={onReschedule}
          booking={booking}
        />
      ) : null}

      {!isCanceled && (
        <>
          <CancelBookingDialog
            trigger={
              <Tooltip title="Cancel session">
                <IconButton>
                  <DeleteOutlinedIcon />
                </IconButton>
              </Tooltip>
            }
            onSuccess={onCancellation}
            confirmationCode={confirmationCode}
          />
          <Tooltip title="Add to calendar">
            <AddToCalendarButton
              icon={EventOutlinedIcon}
              event={makeCalendarEvent(booking)}
            />
          </Tooltip>
        </>
      )}
    </Box>
  )
}

export default ActionButtons
